module.exports = __webpack_public_path__ + "img/KTB.47d06b71.png";